var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiniorangeAuthenticator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50195 9.16667H9.17345V2.5H2.50195V9.16667ZM4.16983 4.16667H7.50558V7.5H4.16983V4.16667Z",
    fill: "#4B475C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50195 17.5007H9.17345V10.834H2.50195V17.5007ZM4.16983 12.5007H7.50558V15.834H4.16983V12.5007Z",
    fill: "#4B475C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8418 2.5V9.16667H17.5133V2.5H10.8418ZM15.8454 7.5H12.5097V4.16667H15.8454V7.5Z",
    fill: "#4B475C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5126 15.834H15.8447V17.5007H17.5126V15.834Z",
    fill: "#4B475C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5097 10.834H10.8418V12.5007H12.5097V10.834Z",
    fill: "#4B475C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1767 12.5H12.5088V14.1667H14.1767V12.5Z",
    fill: "#4B475C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5097 14.166H10.8418V15.8327H12.5097V14.166Z",
    fill: "#4B475C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1767 15.834H12.5088V17.5007H14.1767V15.834Z",
    fill: "#4B475C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8446 14.166H14.1768V15.8327H15.8446V14.166Z",
    fill: "#4B475C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8446 10.834H14.1768V12.5007H15.8446V10.834Z",
    fill: "#4B475C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5126 12.5H15.8447V14.1667H17.5126V12.5Z",
    fill: "#4B475C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniorangeAuthenticator);
export default __webpack_public_path__ + "static/media/miniorange_authenticator.1c9844b3a96b763a40acd21550e170ef.svg";
export { ForwardRef as ReactComponent };